import { toDecimalString } from "../../../../../shared/utils/numbers";

const formaterNumberCell = (value,precision) => value < 0 ? `(${toDecimalString(value*-1,precision)})` : (value>0 ? toDecimalString(value,precision) : '-');
const mayorCien = (value) => value > 0 ? '>100' : '(>100)';

export const subTitlesTableTenObj = (año) => [
    {label:`OBJETIVO ANUAL ${año}`, colIni:0, colFin:5},
    {label:'', colIni:6, colFin:8},
    {label:`TENDENCIA ${año}-CIERRE VS. OBJETIVO ANUAL ${año}`, colIni:9, colFin:33}
]

export const columnsTableTenObj  = (año) =>[
    {
        field: 'conT_OBJ',
        name: 'CONT',
        sortable: false,
        'data-test-subj': 'firstNameCell',
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.conT_OBJ,0)}</span>),
        width:'110px'
    },
    {
        field: 'facT_OBJ',
        name: 'FACT',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.facT_OBJ,0)}</span>),
        width:'110px'
    },
    {
        field: 'proD_OBJ',
        name: 'PROD',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.proD_OBJ,0)}</span>),
        width:'110px'
    },
    {
        field: 'apoR_OBJ',
        name: 'APOR',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.apoR_OBJ,0)}</span>),
        width:'110px'
    },
    {
        field: 'margen_OBJ',
        name: '%MARGEN',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.margen_OBJ)>100 ? mayorCien(data.margen_OBJ) : formaterNumberCell(data.margen_OBJ,1)}</span>),
        width:'100px'
    },
    {
        field: 'bdI_OBJ',
        name: 'BDI',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.bdI_OBJ,0)}</span>),
        width:'110px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'10px'
    },
    
    {
        name: 'Centro',
        'data-test-subj': 'centro',
        sortable: true,
        render: (data) =>(
          <span>{ ((data.idPais!=='@@' && data.idPais!=='A@') ? (data.idPais==='00' ? `NACIONAL` : `INTERNACIONAL`) : `${data.idCentro} - ${data.centro}`)}</span>
        ),
        width:'400px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'10px'
    },
    {
        field: 'cont',
        name: 'CONT',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.cont,0)}</span>),
        width:'110px'
    },
    {
        field: 'conT_TEND_OBJ',
        name: 'IP CONTs/OBJ',
        sortable: false,
        dataType: 'number',
        'data-test-subj': 'IPCell',
        render: (data) => (<span>{Math.abs(data.conT_TEND_OBJ)>100 ? mayorCien(data.conT_TEND_OBJ) : formaterNumberCell(data.conT_TEND_OBJ,2)}</span>),
        width:'90px'
    },
    {
        field: 'conT_TEND_REAL',
        name: `Δ s/${año-1} CONT (%)`,
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.conT_TEND_REAL)>100 ? mayorCien(data.conT_TEND_REAL) : formaterNumberCell(data.conT_TEND_REAL,1)}</span>),
        width:'90px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'10px'
    },
    {
        field: 'fact',
        name: 'FACT',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.fact,0)}</span>),
        width:'110px'
    },
    {
        field: 'facT_TEND_OBJ',
        name: 'IP FACTs/OBJ',
        sortable: false,
        dataType: 'number',
        'data-test-subj': 'IPCell',
        render: (data) => (<span>{Math.abs(data.facT_TEND_OBJ)>100 ? mayorCien(data.facT_TEND_OBJ) : formaterNumberCell(data.facT_TEND_OBJ,2)}</span>),
        width:'90px'
    },
    {
        field: 'facT_TEND_REAL',
        name: `Δ s/${año-1} FACT (%)`,
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.facT_TEND_REAL)>100 ? mayorCien(data.facT_TEND_REAL) : formaterNumberCell(data.facT_TEND_REAL,1)}</span>),
        width:'90px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'10px'
    },
    {
        field: 'prod',
        name: 'PROD',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.prod,0)}</span>),
        width:'110px'
    },
    {
        field: 'proD_TEND_OBJ',
        name: 'IP PRODs/OBJ',
        sortable: false,
        dataType: 'number',
        'data-test-subj': 'IPCell',
        render: (data) => (<span>{Math.abs(data.proD_TEND_OBJ)>100 ? mayorCien(data.proD_TEND_OBJ) : formaterNumberCell(data.proD_TEND_OBJ,2)}</span>),
        width:'90px'
    },
    {
        field: 'proD_TEND_REAL',
        name: `Δ s/${año-1} PROD (%)`,
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.proD_TEND_REAL)>100 ? mayorCien(data.proD_TEND_REAL) : formaterNumberCell(data.proD_TEND_REAL,1)}</span>),
        width:'90px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'10px'
    },
    {
        field: 'apor',
        name: 'APOR',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.apor,0)}</span>),
        width:'110px'
    },
    {
        field: 'apoR_TEND_OBJ',
        name: 'IP APORs/OBJ',
        sortable: false,
        dataType: 'number',
        'data-test-subj': 'IPCell',
        render: (data) => (<span>{Math.abs(data.apoR_TEND_OBJ)>100 ? mayorCien(data.apoR_TEND_OBJ) : formaterNumberCell(data.apoR_TEND_OBJ,2)}</span>),
        width:'90px'
    },
    {
        field: 'apoR_TEND_REAL',
        name: `Δ s/${año-1} APOR (%)`,
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.apoR_TEND_REAL)>100 ? mayorCien(data.apoR_TEND_REAL) : formaterNumberCell(data.apoR_TEND_REAL,1)}</span>),
        width:'90px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'10px'
    },
    {
        field: 'margen',
        name: '%MARGEN',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.margen)>100 ? mayorCien(data.margen) : formaterNumberCell(data.margen,1)}</span>),
        width:'100px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'10px'
    },
    {
        field: 'bdi',
        name: 'BDI',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.bdi,0)}</span>),
        width:'110px'
    },
    {
        field: 'bdI_TEND_OBJ',
        name: 'IP BDIs/OBJ',
        sortable: false,
        dataType: 'number',
        'data-test-subj': 'IPCell',
        render: (data) => (<span>{Math.abs(data.bdI_TEND_OBJ)>100 ? mayorCien(data.bdI_TEND_OBJ) : formaterNumberCell(data.bdI_TEND_OBJ,2)}</span>),
        width:'90px'
    },
    {
        field: 'bdI_TEND_REAL',
        name: `Δ s/${año-1} BDI (%)`,
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.bdI_TEND_REAL)>100 ? mayorCien(data.bdI_TEND_REAL) : formaterNumberCell(data.bdI_TEND_REAL,1)}</span>),
        width:'90px'
    },
    {
        field: 'tipO_MED_IMP',
        name: 'Tipo Medio Impositivo',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.tipO_MED_IMP,1)}</span>),
        width:'100px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'10px'
    },
    {
        field: 'carttotal',
        name: 'CART TOTAL',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.carttotal,0)}</span>),
        width:'110px'
    },
    {
        field: 'carttotaL_TEND_REAL',
        name: `Δ s/${año-1} CART (%)`,
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.carttotaL_TEND_REAL)>100 ? mayorCien(data.carttotaL_TEND_REAL) : formaterNumberCell(data.carttotaL_TEND_REAL,1)}</span>),
        width:'90px'
    }
  ];